/* ==========================================================================
  product.js only for product single page
========================================================================== */

"use strict";

/* global jQuery, $, Splide, Tobii */

jQuery(function ($) {
  /**
   * Handle product color picker change : display color description
   */
  const colorDescriptions = document.querySelectorAll(
    ".colorpicker-info__item"
  );

  $(".variations_form").on("show_variation", function (event, variation) {
    const paColorisValue =
      variation.attributes["attribute_pa_coloris"].toLowerCase();

    colorDescriptions.forEach((colorDescription) => {
      colorDescription.classList.remove("colorpicker-info__item--active");
      if (colorDescription.dataset.coloris === paColorisValue) {
        colorDescription.classList.add("colorpicker-info__item--active");
      }
    });
  });

  /**
   * Handle touch and hold for tooltip
   */
  $(".tooltip").on("touchstart", function (e) {
    e.preventDefault();
    // Show your tooltip here
    const elem = $(this);
    const tooltip = elem.find(".tooltip__text");
    tooltip.addClass("tooltip__text--active");
  });

  $(".tooltip").on("touchend", function () {
    const elem = $(this);
    const tooltip = elem.find(".tooltip__text");
    tooltip.addClass("tooltip__text--active");
  });
});

/**
 * Handle product gallery slider
 *
 * @returns void
 */
const productSlider = () => {
  const productSlider = document.querySelector(".product-slider");

  if (!productSlider) {
    return;
  }

  const main = new Splide("#product-slider-main", {
    type: "fade",
    rewind: true,
    arrows: false,
    mediaQuery: "min",
    classes: {
      pagination: "splide__pagination splide__pagination--product",
    },
    breakpoints: {
      889: {
        pagination: false,
        padding: {
          right: "2.25rem",
          left: "2.25rem",
        },
      },
    },
  });

  const thumbnails = new Splide("#product-slider-thumbnails", {
    rewind: true,
    pagination: false,
    focus: "center",
    isNavigation: true,
    gap: "2.25rem",
    padding: {
      top: "1.25rem",
      right: "0.625rem",
      bottom: "1.25rem",
      left: "0.625rem",
    },
    perPage: 4,
    breakpoints: {
      889: {
        destroy: true,
      },
      1180: {
        perPage: 2,
      },
      1280: {
        perPage: 3,
      },
    },
  });

  main.sync(thumbnails);
  main.mount();
  thumbnails.mount();

  const tobii = new Tobii({
    captions: false,
    zoom: false,
  });

  tobii.on("previous", () => {
    main.go("<");
  });

  tobii.on("next", () => {
    main.go(">");
  });
};

/**
 * Handle product 3D model fading slider
 *
 * @returns void
 */
const modelSlider = () => {
  const carrousel = document.getElementById("model-carousel");

  if (!carrousel) {
    return;
  }

  const splide = new Splide("#model-carousel", {
    type: "fade",
    pagination: false,
    arrows: false,
  });

  const colors = document.querySelectorAll(".model-navigation__item");
  let current;

  for (let i = 0; i < colors.length; i++) {
    initThumbnail(colors[i], i);
  }

  function initThumbnail(color, index) {
    color.addEventListener("click", function () {
      splide.go(index);
    });
  }

  splide.on("mounted move", function () {
    const color = colors[splide.index];

    if (color) {
      if (current) {
        current.classList.remove("is-active");
      }

      color.classList.add("is-active");
      current = color;
    }
  });

  splide.mount();
};

/**
 * Handle product tabs accordion
 *
 * @returns void
 */
const productAccordion = () => {
  const accordion = document.querySelector(".product-tabs__inner");

  if (!accordion) {
    return;
  }

  new Accordion(accordion, {
    duration: 400,
    showMultiple: false,
    elementClass: "product-tab",
    triggerClass: "product-tab__header",
    panelClass: "product-tab__panel",
  });
};

document.addEventListener("DOMContentLoaded", () => {
  productSlider();
  modelSlider();
  productAccordion();
});
